import { render, staticRenderFns } from "./SoloResult.vue?vue&type=template&id=4563ba54&scoped=true&"
import script from "./SoloResult.vue?vue&type=script&lang=ts&"
export * from "./SoloResult.vue?vue&type=script&lang=ts&"
import style0 from "./SoloResult.vue?vue&type=style&index=0&id=4563ba54&scoped=true&lang=scss&"
import style1 from "./SoloResult.vue?vue&type=style&index=1&id=4563ba54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4563ba54",
  null
  
)

export default component.exports